import React from "react";

export default function Comission() {
  return (
    <div className="Comission question-routes-container">
      <h1>Комиссии на платформе FITT</h1>
      <p>
        Одним из преимуществ использования платформы FItt является отсутствие
        дополнительных комиссий, за исключением абонентской платы. Все комиссии,
        которые могут быть взимаемы во время торговли, представляют собой
        стандартные комиссии Binance.
      </p>
      <p>
        <b>Стандартные комиссии Binance:</b>
      </p>
      <ol className="questions-inner-list">
        <li>
          Торговые комиссии: Binance взимает комиссию за каждую сделку, которую
          вы совершаете на платформе. Размер комиссии зависит от вашего
          торгового объема и уровня верификации аккаунта. Чем больше вы торгуете
          и чем выше уровень верификации, тем меньше комиссия.
        </li>
        <li>
          Ввод и вывод средств: Binance может взимать комиссии за ввод или вывод
          средств с вашего аккаунта. Комиссии за ввод, как правило, отсутствуют,
          однако комиссии за вывод могут варьироваться в зависимости от
          выбранной криптовалюты и сети.
        </li>
        <li>
          Комиссии за маржинальную торговлю: Если вы используете маржинальную
          торговлю на Binance, платформа взимает комиссии за заемные средства и
          сделки с использованием кредитного плеча. Размеры комиссий могут
          изменяться в зависимости от условий рынка и выбранной пары.
        </li>
      </ol>
      <p className="mt-3">
        Учитывая, что FITT не взимает дополнительные комиссии, за исключением
        абонентской платы, трейдеры и инвесторы могут сосредоточиться на
        оптимизации своих торговых стратегий и управлении рисками, не беспокоясь
        о дополнительных издержках. Отметим, что абонентская плата покрывает
        доступ к функциям социального трейдинга, обучающим материалам и другим
        полезным ресурсам на платформе FItt, что делает использование платформы
        привлекательным и выгодным для трейдеров разного уровня опыта.
      </p>
    </div>
  );
}
